import styled from "styled-components";

export default styled.span`
    position: relative;

  background: ${props => (props.selected ? "#43275b" : "#683d8c")};
  display: flex;

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    width: 20%;
    justify-content: center;
  }

  cursor: pointer;

  a {
    display: flex;
    align-items: center;
    padding: 1em;
    color: #fff;
    font-size: 2em;
    text-decoration: none;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      display: flex;
      flex-direction: column;
      font-size: 1.75em;
      padding: 0.5em;
    }
  }

  &:hover {
    background: #4b2e6b;
  }
`;
